import React from 'react';
import Form from 'react-bootstrap/Form'
import { Field } from 'redux-form';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import bt from '../../../components/commonStyle.css';


function RadioFieldComponent(props) {

    const { name, onChange, inputClass, label, labelClass, containerClassName, value, isTick, size = 20 } = props;

    return (
        <Form.Label className={cx(bt.noMargin, 'customRadioBtnContainer', containerClassName)}>
            <Field
                name={name}
                type="radio"
                value={value}
                className={inputClass}
                component="input"
                style={{ width: `${size}px`, height: `${size}px` }}
                onChange={onChange}
            />
            <span className={isTick ? 'customRadioCheckTick' : 'customRadioCheckDot'} style={{ "--customRadioWidth": `${size}px`, "--customRadioHeight": `${size}px` }} />
            {label && <span className={labelClass}>{label}</span>}
        </Form.Label>
    )
}

export default withStyles(bt)(RadioFieldComponent);